import http from '../../../http'

const state = {
    sendList: [],
    page: {
        current: 1,
        pageSize: 15,
        pageSizes: [15,30,50,100],
        total: 0
    },

};

const mutations = {
    SET_SEND_LIST: (state, payload)=> {
        state.sendList = payload;
    },
    SET_PAGE_CURRENT(state, current) {
        state.page.current = current;
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.page.pageSize = pageSize;
    },
    SET_PAGE_TOTAL(state, total) {
        state.page.total = total;
    }

};

const actions = {
    getSendList: ({commit}, payload) =>{
        let params = {};
        params.current = state.page.current;
        params.size = state.page.pageSize;
        params.keyword = payload;
        return new Promise((resolve =>{
            http.post('/supplier-resource/send/loadSend', params).then((res)=>{
                if(res.data.code === '200') {
                    commit('SET_SEND_LIST', res.data.data.records)
                    commit('SET_PAGE_TOTAL', res.data.data.total)
                    resolve(res.data);
                }else {
                    resolve(res);
                }
            })
        }));
    },

    printSend({commit, state}, payload) {
        return new Promise((resolve) => {
            http.post('/supplier-resource/send/printSend', {sendId: payload}).then((res)=>{
                resolve(res.data);
            });
        })
    },

    getPreSendOrderDetailList: ({commit}, payload) =>{
        return new Promise((resolve =>{
            http.post('/supplier-resource/send/getPreSendOrderDetailList', payload).then((res)=>{
                if(res.data.code === '200') {
                    resolve(res.data.data);
                }
            })
        }));
    },

    getSendDetailList: ({commit}, payload) =>{
        return new Promise((resolve =>{
            http.post('/supplier-resource/send/getSendDetailList?sendId='+payload).then((res)=>{
                if(res.data.code === '200') {
                    resolve(res.data.data);
                }else {
                    resolve(res);
                }
            })
        }));
    },

    preSendOrderList: ({commit}, payload)=>{
        return new Promise((resolve =>{
            http.post('/supplier-resource/send/preSendOrderList').then((res)=>{
                resolve(res.data);
            })
        }));
    },

    saveSend: ({commit}, payload) =>{
        return new Promise((resolve =>{
            http.postObj('/supplier-resource/send/saveSend', JSON.stringify(payload)).then((res)=>{
                resolve(res.data);
            })
        }));
    },

    getCompList: ({commit}, payload) =>{
        return new Promise((resolve =>{
            http.postObj('/supplier-resource/send/getCompList', JSON.stringify(payload)).then((res)=>{
                resolve(res.data);
            })
        }));
    },

    saveSendDetail: ({commit}, payload) =>{
        return new Promise((resolve =>{
            http.postObj('/supplier-resource/send/saveSendDetail', JSON.stringify(payload)).then((res)=>{
                resolve(res.data);
            })
        }));
    },

    deleteSendDetail: ({commit}, payload) =>{
        return new Promise((resolve =>{
            http.post('/supplier-resource/send/deleteSendDetail', {ids: payload}).then((res)=>{
                resolve(res.data);
            })
        }));
    },

    deleteSend: ({commit}, payload) =>{
        return new Promise((resolve =>{
            http.post('/supplier-resource/send/deleteSend', payload).then((res)=>{
                resolve(res.data);
            })
        }));
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
